import { TaskService } from '@/services'
import { config } from '@/config'
import { HttpMethod, TaskResponse } from '@/interfaces/task'

export class PushController {
  static async subscribe(payload: {
    registrantId: number
    subscription: object
  }): Promise<TaskResponse<{ id: number }>> {
    const url = config.api.endpoints.push.subscribe
    const body = {
      registrantId: payload.registrantId,
      data: payload.subscription,
    }
    return TaskService.execute({ url, method: HttpMethod.POST, body })
  }
}
